module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-1@2x-80b937367ad7fbf1b116cddcb2f7bae6.png";